export default __webpack_public_path__ + "assets/svg-sprite.af50ee6bdad3b15c2d52daaa2a7d4fa7.svg";